import React from 'react';

import AppErrorIcon from '../AppErrorIcon';
import AppErrorTitle from '../AppErrorTitle';
import styles from '../AppError.module.css';

interface Props {
  hash?: string;
}

const AppErrorBlockConsensus = ({ hash }: Props) => {
  return (
    <>
      <AppErrorIcon statusCode={ 404 }/>
      <AppErrorTitle title="Block removed due to chain reorganization"/>
      <a href={ hash ? `/block/${ hash }` : '/' } className={ styles.backButton }>
        { hash ? 'View reorg' : 'Back to home' }
      </a>
    </>
  );
};

export default AppErrorBlockConsensus;
